import type { IQBLinkageHandler } from '../types';
import type { ICrosstabConfig } from '../../../../utils/crosstab';
import { hasConfigInLayers, patchBoth } from './shared';
import { syncCrosstabFromQBChange } from '../../../../utils/crosstab';

export const crosstabHandler: IQBLinkageHandler = {
  id: 'crosstab',
  phase: 'sync',
  keys: ['crosstab'],
  subscribe: [
    'dimensionAdded',
    'dimensionRemoved',
    'dimensionReordered',
    'metricAdded',
    'metricRemoved',
    'metricReordered',
    'fieldIdentityRenamed',
    'dimCountChanged',
    'metricCountChanged',
  ],
  apply(changeSet, ctx) {
    if (!hasConfigInLayers(ctx.base, ctx.draft, 'crosstab')) {
      return;
    }
    const existing = (ctx.draft.crosstab ?? ctx.base.crosstab) as
      | ICrosstabConfig
      | undefined;

    const synced = syncCrosstabFromQBChange({
      existing,
      columnDimensions: ctx.qb.columnDimensions,
      columnMetrics: ctx.qb.columnMetrics,
      addedDimensions: changeSet.addedDimensions,
      addedMetrics: changeSet.addedMetrics,
      removedDimensions: changeSet.removedDimensions,
      removedMetrics: changeSet.removedMetrics,
      identityRenames: changeSet.renamed,
    });

    if (!synced) {
      return;
    }

    return patchBoth({ crosstab: synced }, { crosstab: synced });
  },
};
